export default __webpack_public_path__ + "static/media/cartas_de_linguagem.72005907.png";